"use client";
import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import SafeLink from "@/components/SafeLink";

// 折叠面板项的接口
interface CollapseItem {
  urlName: string; // id
  title: string; // 面板标题
  content?: string; // 如果没有子项，则显示此内容
}

// 组件的Props
interface CollapsePanelProps {
  items: CollapseItem[]; // 面板项数组
  detailId: string | undefined;
  getDetail: (urlName: string) => void;
}

const btnStyle = {
  paddingTop: "16px",
  paddingBottom: "20px",
  borderBottom: "1px solid #F0F1F2",
  "&.Mui-selected": {
    color: "#FF0F23",
    backgroundColor: "#FFF",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#F5F6FA",
  },
  "&:hover": {
    color: "#FF0F23",
    backgroundColor: "#F5F6FA",
  },
  "&:active": {
    backgroundColor: "#FFF",
  },
};

const itemStyle = {
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "20px",
  margin: 0,
  "& .MuiListItemText-primary": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const CollapsePanel: React.FC<CollapsePanelProps> = (props) => {
  // -------------------------------------- //
  const { items, detailId, getDetail } = props;

  // ------------------------------------- //
  return (
    <List sx={{ width: "100%", bgcolor: "background.paper" }} component="nav" aria-labelledby="nested-list-subheader">
      {items.map((item, index) => (
        <SafeLink key={item.urlName} onClick={() => getDetail(item.urlName)} href={`/help/${item.urlName}`}>
          <ListItemButton sx={index === items.length - 1 ? { ...btnStyle, borderBottom: "none" } : btnStyle} selected={detailId === item.urlName} disableRipple>
            <ListItemText primary={item.title} sx={itemStyle} />
          </ListItemButton>
        </SafeLink>
      ))}
    </List>
  );
};

export default CollapsePanel;
